import {OtsUIState} from "../../ots-ui-store";

export const selectUIPipelineFlowTransportSearchFilter = (state: OtsUIState) => state.uiPipelineFlowTransport.searchFilter
